import { render, staticRenderFns } from "./VoiceBar.vue?vue&type=template&id=2ef4b4d6&scoped=true&"
import script from "./VoiceBar.vue?vue&type=script&lang=js&"
export * from "./VoiceBar.vue?vue&type=script&lang=js&"
import style0 from "./VoiceBar.vue?vue&type=style&index=0&id=2ef4b4d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4b4d6",
  null
  
)

export default component.exports